import { useUiStore } from '@/state/uiStore.js';
import Toast from './Toast.jsx';

/**
 * Container for the toast stack. The monolith renders into a DOM node
 * with id="toastContainer"; we keep the same id so any inline-styled
 * extracted CSS that references it still applies.
 */
export default function ToastContainer() {
  const toasts = useUiStore((s) => s.toasts);
  return (
    <div id="toastContainer" className="toast-container" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <Toast key={t.id} toast={t} />
      ))}
    </div>
  );
}
